import { useContext } from 'react';
import '../../../styles/home.css';
import TopStories from './topStories.jsx';
import PoliticalNews from './politicalNews.jsx';
import { Helmet } from 'react-helmet-async';
import { DeviceContext } from '../index.jsx';
import PageAds from '../../common/pageAds.jsx';

const categoryMap = {
    'politics-39.html': {
    firstStep: 'రాజకీయం',
    link:"/contents/politics-39.html",
    catId: 39,
    pageTitle: 'Andhra Pradesh Political Gossip | Andhra Pradesh Political News | AP Political News | Political Gossips',
  },
     'andhrapradesh-43.html': {
    firstStep: 'ఆంధ్రప్రదేశ్',
    catId: 43,
    link:"/contents/andhrapradesh-43.html",
    pageTitle: 'Andhra Pradesh Political Gossip | Andhra Pradesh Political News | AP Political News | Political Gossips',
  },
     'telangana-24.html': {
    firstStep: 'తెలంగాణ',
    catId: 24,
    link:"/contents/telangana-24.html",
    pageTitle: 'Andhra Pradesh Political Gossip | Andhra Pradesh Political News | AP Political News | Political Gossips',
  },
     'india-23.html': {
    firstStep: 'భారత్',
    catId: 23,
    link:"/contents/india-23.html",
    pageTitle: 'Andhra Pradesh Political Gossip | Andhra Pradesh Political News | AP Political News | Political Gossips',
  },
     'world-58.html': {
    firstStep: 'ప్రపంచం',
    catId: 58,
    link:"/contents/world-58.html",
    pageTitle: 'Andhra Pradesh Political Gossip | Andhra Pradesh Political News | AP Political News | Political Gossips',
  },  
   'business-54.html': {
    firstStep: 'బిజినెస్',
    catId: 54,
    link:"/contents/business-54.html",
    pageTitle: 'Andhra Pradesh Political Gossip | Andhra Pradesh Political News | AP Political News | Political Gossips',
  },
  'technology-33.html': {
    firstStep: 'టెక్నాలజీ',
    catId: 33,
    link:"/contents/technology-33.html",
    pageTitle: 'Andhra Pradesh Top Story | Telugu Top Story News | Top Story | Top Story News',
  },
  'sports-53.html' : {
     firstStep: 'క్రీడలు',
    catId: 53,
    link:"/contents/sports-53.html",
    pageTitle: 'Andhra Pradesh Top Story | Telugu Top Story News | Top Story | Top Story News',
  },
  'teluguoneexclusive-55.html' : {
        firstStep: 'తెలుగువన్ ప్రత్యేకం',
       catId: 55,
       link:"/contents/teluguoneexclusive-55.html",
       pageTitle: 'TeluguOne Exclusive News | Andhra Pradesh Political News | AP Political News | Political Gossips',
  },
   'history-57.html' : {
        firstStep: 'చరిత్ర',
       catId: 57,
       link:"/contents/history-57.html",
       pageTitle: 'TeluguOne Exclusive Historical News | Andhra Pradesh Political News | AP Political News | Political Gossips',
  },
 

  // 'political-39.html': {
  //   firstStep: 'Politics',
  //   catId: 39,
  //   pageTitle: 'Andhra Pradesh Political Gossip | Andhra Pradesh Political News | AP Political News | Political Gossips',
  // },
   'analytical-45.html': {
    firstStep: 'సంపాదకీయం',
    catId: 45,
     link:"/contents/analytical-45.html",
    pageTitle: 'Andhra Pradesh Analytical News | Andhra Pradesh Political News | AP Political News | Political Gossips',
  },
  // 'lifestyle-35.html': {
  //   firstStep: 'lifestyle',
  //   catId: 35,
  //   pageTitle: 'Life Style | Daily Life Style | Urban Life Style | Healthy Living',
  // },
  // 'health-34.html': {
  //   firstStep: 'healthnews',
  //   catId: 34,
  //   pageTitle: 'Health Topics | Health Diets | Health Details',
  // },
  // 'specialAnalysis-60.html': {
  //   firstStep: 'specialAnalysis',
  //   catId: 60,
  //   pageTitle: 'Special Stories | Investments | More',
  // }
};


const Home = ({ data }) => {
  const homeData = data?.[0]?.homePageData || {};
  const { mobile, containerRef } = useContext(DeviceContext);
const categoryData = {};

Object.values(categoryMap).forEach(category => {

  const key = `category_${category.catId}`;

  if (Array.isArray(homeData[key])) {
    categoryData[category.catId] = homeData[key];
  }

});
  const d = homeData || {};

  return (
    <div className="news-loader">
      <Helmet><title>AP Regional News|AP political news|Andhra Political Gossips|Telugu cinema news|Telugu movie gossips|Telugu NRI news</title></Helmet>

     
     <TopStories
        newsSlickData={d.newsSlickData}
        newsSlickError={d.newsSlickDataError}
      /> 

    
       <PoliticalNews
          categoryMap={categoryMap}
          categoryData={categoryData || {}}
        />

      <PageAds mobile={mobile} containerRef={containerRef} />
    </div>
  );
};

export default Home;
